// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#14567E","primaryBackgroundColor":"#f1f0f0","secondaryBackgroundColor":"#fff","primaryTextColor":"rgba(0,0,0,0.87)"};